import * as legacyHelper from "./legacy-helper/legacy-helper.service";
import * as oAuth from "./o-auth/o-auth.service";
import * as pushToCloud from "./push-to-cloud/push-to-cloud.service";
import * as remoteConfig from "./remote-config/remote-config.service";
import * as security from "./security/security.service";

// FIXME: These services are only imported to get around optional services
//        used in a mandatory way :(
import * as dogear from './../kobo/dogear/dogear.service';
import * as googleAnalytics from './../common/google-analytics/google-analytics.service';
import * as highlight from './../kobo/highlight/highlight.service';
import * as session from './../kobo/session/session.service';

export default [
  dogear,
  googleAnalytics,
  highlight,
  legacyHelper,
  oAuth,
  pushToCloud,
  remoteConfig,
  security,
  session
];
